import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { NexpoWorkspace } from '@soft2code/nexpo-lib/core';
import { map } from 'rxjs';

/**
 * Só entra no portal com uma feira escolhida. Sem isso, um F5 em `/contacts`
 * abriria os contatos sem saber de qual edição — e o expositor leria os de
 * uma feira achando que são de outra.
 *
 * ⚠️ Ter o id não basta: ele sobrevive ao F5, a lista de feiras não, e é dela
 * que sai o nome no topo. Conferir só o id fazia o nome sumir (medido no admin
 * em 2026-09-02).
 */
export const activeEventGuard: CanActivateFn = () => {
	const workspace = inject(NexpoWorkspace);
	const router = inject(Router);
	if (workspace.hasActive() && workspace.events().length > 0) return true;
	return workspace.load().pipe(map(() => workspace.hasActive() || router.createUrlTree(['/fairs'])));
};
